exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.header {\n  margin-bottom: 25px; }\n\n.form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.form__group {\n    margin-bottom: 20px; }\n\n.form__input {\n    width: 250px;\n    padding: 7px 10px;\n    border-radius: 2px;\n    border: 1px solid grey; }\n\n.form__input:focus {\n      outline: none;\n      -webkit-box-shadow: 0.2rem 0.8rem 1.6rem #CCC;\n              box-shadow: 0.2rem 0.8rem 1.6rem #CCC; }\n\n.form__label {\n    min-width: 150px; }\n\n.form__button {\n    padding: 5px 15px;\n    font-weight: bold;\n    text-transform: capitalize; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/login/login.component.scss
// module id = ../../../../../src/app/pages/login/login.component.scss
// module chunks = main